export const API_PATH_apiWorkzoneItemPost = '/services/workzones-management/item';
